// extracted by mini-css-extract-plugin
module.exports = {"main":"templateStyles_main__ie4hp","stack":"templateStyles_stack__PU5kf"};